// extracted by mini-css-extract-plugin
export var banner = "_t6-0";
export var settingRow = "_t6-2";
export var titleIcon = "_t6-1";